export const APP_CONFIG_CONTAINER_INVALID_CONFIG = 'AppConfigContainer#validateSetConfigParams: invalid config';
